export const minimumLengthOfSearch = 3;